import { TableRow as MuiTableRow, TableCell } from '@mui/material'

export type TableRowInformation = {
  [key: string]: string | React.ReactNode | number | unknown
  onClick?: () => void
}

export type TableRowProps = {
  row: TableRowInformation
  rowIndex: number
  tableHead: string[]
  lastCellRight: boolean
}

const TableRow = (props: TableRowProps) => (
  <MuiTableRow
    key={props.rowIndex}
    hover={!!props.row.onClick}
    sx={props.row.onClick ? { cursor: 'pointer' } : undefined}
    onClick={props.row.onClick}
  >
    {props.tableHead.map((cell, cellIndex) => {
      const value = props.row[cell]
      const cellContent = typeof value === 'function' ? '' : (value as React.ReactNode)

      return (
        <TableCell
          scope="row"
          key={`${props.rowIndex}-${cellIndex}`}
          align={props.tableHead.length === cellIndex + 1 && props.lastCellRight ? 'right' : 'inherit'}
        >
          {cellContent || ''}
        </TableCell>
      )
    })}
  </MuiTableRow>
)

export default TableRow
